<template>
    <div class="container">
        <div class="row">
            <div class="col-xl-6 mb-3">
                <div class="card p-3">
                    <div class="card-body">
                        <div class="card-title">
                            <i class="fas fa-database mr-2"> </i> 
                            <span class="font-weight-bold">Actualiza tus datos</span>
                        </div>
                        <div class="col-12">
                        <div class="form-group">
                            <label for="password" class="text-center" ref="password">Nombre: </label>
                            <input v-validate="''" name="name" data-vv-as="nombre" type="text" class="form-control" id="name" v-model="entity.name">
                            <span class="validation-error">{{errors.first('name')}}</span>
                        </div>
                        <div class="form-group">
                            <label for="password" class="text-center" ref="password">Correo: </label>
                            <input v-validate="'email'" name="email" data-vv-as="correo" type="text" class="form-control" id="email" v-model="entity.email">
                            <span class="validation-error">{{errors.first('email')}}</span>
                        </div>
                        <div class="form-group">
                            <label for="password" class="text-center" ref="password">Contraseña: </label>
                            <input v-validate="'min:8'" name="password" data-vv-as="contraseña" type="password" class="form-control" id="password" ref="password" v-model="entity.password">
                            <span class="validation-error">{{errors.first('password')}}</span>
                        </div>
                        <div class="form-group">
                            <label  for="password_confirmation" class="text-center">Confirmación de contraseña: </label>
                            <input v-validate="'min:8|confirmed:password'" name="password_confirmation" data-vv-as="confirmación" type="password" class="form-control" id="password_confirmation" v-model="entity.password_confirmation">
                            <span class="validation-error">{{errors.first('password_confirmation')}}</span>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label for="document" class="text-center">NIT o Registro</label>
                                <input v-validate="''" name="document" data-vv-as="NIT o Registro" type="text" class="form-control" id="document" v-model="entity.document">
                                <span class="validation-error">{{errors.first('document')}}</span>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="phone_number" class="text-center">Teléfono: </label>
                                <input v-validate="'min:7'" name="phone_number" data-vv-as="número telefónico" type="number" class="form-control" id="phone_number" v-model="entity.phone_number">
                                <span class="validation-error">{{errors.first('phone_number')}}</span>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="name">Domicilio</label>
                            <textarea v-validate="'max:256'" name="address" data-vv-as="domicilio" type="text" class="form-control" placeholder="Dirección de la dependencia" rows="4" v-model="entity.address"></textarea>
                            <span class="validation-error">{{errors.first('address')}}</span>
                        </div>
                    </div>
                        <input type="button" class="btn btn-info btn-block" value="Actualizar datos" @click.prevent="changePassword">
                    </div>
                </div>
            </div>
            <div class="col-xl-6 mb-3">
                <div class="card">
                    <div class="card-body">
                        <p>Para cambiar tu contraseña ten en cuenta las siguientes recomendaciones</p>
                        <ul>
                            <li>La contraseña debe tener mínimo 8 caracteres, pero te recomendamos usar contraseñas más largas, más difícil de descifrar.</li>
                            <li>Intenta mezclando números, letras y caracteres especiales</li>
                            <li>No uses información personal en las contraseñas</li>
                            <li>No uses contraseñas que hayas usado en otros lugares</li>
                            <li>Cambia tu contraseña regularmente</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'password',
    data(){
        return {
            password: "",
            password_confirmation: "",
            apiUrl: process.env.VUE_APP_API,
            user: JSON.parse(localStorage.getItem("user")),
            token: localStorage.getItem("session_id"),
            entity: JSON.parse(localStorage.getItem("user"))
        }
    },
    computed: {
        passwordUrl: function(){
            return `${this.apiUrl}/${this.user.type}/entities/${this.user.id}`;
        }
    },
    methods: {
        changePassword: function(){
            let loader = this.$loading.show();
            this.$http.put(
                this.passwordUrl, 
                this.entity,
                {headers: {Authorization: `Bearer ${this.token}`}})
                .then(data => {
                    this.$dialogs.alert("Datos actualizados exitosamente, debe volver a iniciar sesión", {title: "Éxito", size: "sm"});
                    loader.hide();
                    localStorage.clear();
                    this.$router.push("/");
                })
                .catch(error => {
                    this.$dialogs.alert("Hubo un error al momento de actualizar sus datos, contacte a su administrador.", {title: "Error", size: "sm"});
                    loader.hide();
                })
        }
    }
}
</script>
<style lang="scss" scoped>
    .validation-error {
        color: red;
        font-size: 14px;
    }
</style>


